export default "/fonts/fa-regular-400.ttf?3cd9fb8fcec4ad0f99d4062cd547a4ba";